import { render, staticRenderFns } from "./DecorFacets.vue?vue&type=template&id=c7caf586&scoped=true"
import script from "./DecorFacets.vue?vue&type=script&lang=js"
export * from "./DecorFacets.vue?vue&type=script&lang=js"
import style0 from "./DecorFacets.vue?vue&type=style&index=0&id=c7caf586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7caf586",
  null
  
)

export default component.exports